import { render, staticRenderFns } from "./provinceDetail.vue?vue&type=template&id=37818362&scoped=true"
import script from "./provinceDetail.vue?vue&type=script&lang=js"
export * from "./provinceDetail.vue?vue&type=script&lang=js"
import style1 from "./provinceDetail.vue?vue&type=style&index=1&id=37818362&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37818362",
  null
  
)

export default component.exports